import { getProductListApi } from 'src/api/productApi';
import { GET_LIST_FOR_PRODUCT } from 'src/redux/Actions/Type';

export function getProductList(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  selectedFilterOption,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  queryString,
) {
  return (dispatch) => {
    getProductListApi(
      tenantOrganisationId,
      pageNumber,
      searchInput,
      selectedFilterOption,
      tableSortOrder,
      tableSortField,
      tableFieldFilter,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_LIST_FOR_PRODUCT,
        payload: data,
      });
      return Promise.resolve(data);
    });
  };
}
